import { cessionRequestingPlatformCodeOverrideVar } from '../apollo/reactive-variables/platform';

const getCessionRequestingPlatformCode = () => (
  cessionRequestingPlatformCodeOverrideVar() || null
);

export default getCessionRequestingPlatformCode;
